import { css, keyframes, styled } from "styled-components";

const SearchAudioWave = () => {
  return (
    <StyledSearchAudioWave
      width="739"
      height="60"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        fill="#E5E9FF"
        d="m0.05962,14.25334c0,-1.3792 1.40457,-2.50407 3.11717,-2.50407c1.72491,0 3.11717,1.11509 3.11717,2.50407l0,32.50306c0,1.389 -1.40458,2.5041 -3.11717,2.5041c-1.72492,0 -3.11717,-1.1249 -3.11717,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m12.10942,10.25334c0,-1.38898 1.4169,-2.51386 3.1664,-2.51386c1.7496,0 3.1665,1.12488 3.1665,2.51386l0,39.50306c0,1.389 -1.4169,2.5139 -3.1665,2.5139c-1.7495,0 -3.1664,-1.1249 -3.1664,-2.5139l0,-39.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m24.24542,14.25334c0,-1.38898 1.4046,-2.50407 3.1171,-2.50407c1.725,0 3.1172,1.11509 3.1172,2.50407l0,32.50306c0,1.389 -1.4046,2.5041 -3.1172,2.5041c-1.7249,0 -3.1171,-1.1151 -3.1171,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m36.30752,18.5331c0,-1.389 1.4169,-2.5139 3.1664,-2.5139c1.7496,0 3.1665,1.1249 3.1665,2.5139l0,23.9534c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m48.39422,21.1868c0,-1.389 1.4169,-2.5138 3.1664,-2.5138c1.7496,0 3.1665,1.1248 3.1665,2.5138l0,17.6264c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m60.49322,15.5331c0,-1.389 1.4169,-2.5139 3.1665,-2.5139c1.7496,0 3.1664,1.1249 3.1664,2.5139l0,28.9534c0,1.389 -1.4168,2.5138 -3.1664,2.5138c-1.7496,0 -3.1665,-1.1248 -3.1665,-2.5138l0,-28.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m72.05962,14.25334c0,-1.38898 1.4045,-2.50407 3.1171,-2.50407c1.7249,0 3.1172,1.11509 3.1172,2.50407l0,32.50306c0,1.389 -1.4046,2.5041 -3.1172,2.5041c-1.7249,0 -3.1171,-1.1151 -3.1171,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m90.70165,15.5331c0,-1.389 -1.4168,-2.5139 -3.1664,-2.5139c-1.7496,0 -3.1665,1.1249 -3.1665,2.5139l0,28.9534c0,1.389 1.4169,2.5138 3.1665,2.5138c1.7496,0 3.1664,-1.1248 3.1664,-2.5138l0,-28.9534z"
      />
      <path
        stroke="null"
        fill="#E5E9FF"
        d="m102.12362,20.1868c0,-1.389 -1.417,-2.5138 -3.1668,-2.5138c-1.7495,0 -3.1664,1.1248 -3.1664,2.5138l0,17.6264c0,1.389 1.4169,2.5138 3.1664,2.5138c1.7498,0 3.1668,-1.1248 3.1668,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m114.88705,18.5331c0,-1.389 -1.416,-2.5139 -3.166,-2.5139c-1.75,0 -3.166,1.1249 -3.166,2.5139l0,23.9534c0,1.389 1.416,2.5138 3.166,2.5138c1.75,0 3.166,-1.1248 3.166,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m126.62749,14.25334c0,-1.38898 -1.405,-2.50407 -3.118,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.118,-1.1151 3.118,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m138.77549,10.51386c0,-1.38898 -1.417,-2.51386 -3.167,-2.51386c-1.749,0 -3.166,1.12488 -3.166,2.51386l0,39.97224c0,1.389 1.417,2.5139 3.166,2.5139c1.75,0 3.167,-1.1249 3.167,-2.5139l0,-39.97224z"
      />
      <path
        fill="#E5E9FF"
        d="m144.48297,14.25334c0,-1.38898 1.4046,-2.50407 3.1171,-2.50407c1.725,0 3.1172,1.11509 3.1172,2.50407l0,32.50306c0,1.389 -1.4046,2.5041 -3.1172,2.5041c-1.7249,0 -3.1171,-1.1151 -3.1171,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m156.54507,18.5331c0,-1.389 1.4169,-2.5139 3.1664,-2.5139c1.7496,0 3.1665,1.1249 3.1665,2.5139l0,23.9534c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m168.3092,21.1868c0,-1.389 1.4169,-2.5138 3.1664,-2.5138c1.7496,0 3.1665,1.1248 3.1665,2.5138l0,17.6264c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m180.4082,15.5331c0,-1.389 1.4169,-2.5139 3.1665,-2.5139c1.7496,0 3.1664,1.1249 3.1664,2.5139l0,28.9534c0,1.389 -1.4168,2.5138 -3.1664,2.5138c-1.7496,0 -3.1665,-1.1248 -3.1665,-2.5138l0,-28.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m192.5443,14.25334c0,-1.38898 1.4045,-2.50407 3.1171,-2.50407c1.7249,0 3.1172,1.11509 3.1172,2.50407l0,32.50306c0,1.389 -1.4046,2.5041 -3.1172,2.5041c-1.7249,0 -3.1171,-1.1151 -3.1171,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m210.61664,15.5331c0,-1.389 -1.4168,-2.5139 -3.1664,-2.5139c-1.7496,0 -3.1665,1.1249 -3.1665,2.5139l0,28.9534c0,1.389 1.4169,2.5138 3.1665,2.5138c1.7496,0 3.1664,-1.1248 3.1664,-2.5138l0,-28.9534z"
      />
      <path
        stroke="null"
        fill="#E5E9FF"
        d="m222.68373,20.1868c0,-1.389 -1.417,-2.5138 -3.1668,-2.5138c-1.7495,0 -3.1664,1.1248 -3.1664,2.5138l0,17.6264c0,1.389 1.4169,2.5138 3.1664,2.5138c1.7498,0 3.1668,-1.1248 3.1668,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m234.80204,18.5331c0,-1.389 -1.416,-2.5139 -3.166,-2.5139c-1.75,0 -3.166,1.1249 -3.166,2.5139l0,23.9534c0,1.389 1.416,2.5138 3.166,2.5138c1.75,0 3.166,-1.1248 3.166,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m246.54247,14.25334c0,-1.38898 -1.405,-2.50407 -3.118,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.118,-1.1151 3.118,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m258.69047,10.51386c0,-1.38898 -1.417,-2.51386 -3.167,-2.51386c-1.749,0 -3.166,1.12488 -3.166,2.51386l0,39.97224c0,1.389 1.417,2.5139 3.166,2.5139c1.75,0 3.167,-1.1249 3.167,-2.5139l0,-39.97224z"
      />
      <path
        fill="#E5E9FF"
        d="m270.72747,14.25334c0,-1.38898 -1.404,-2.50407 -3.117,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.117,-1.1151 3.117,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m276.42693,18.5331c0,-1.389 1.4169,-2.5139 3.1664,-2.5139c1.7496,0 3.1665,1.1249 3.1665,2.5139l0,23.9534c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m288.51363,21.1868c0,-1.389 1.4169,-2.5138 3.1664,-2.5138c1.7496,0 3.1665,1.1248 3.1665,2.5138l0,17.6264c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m300.29007,15.5331c0,-1.389 1.4169,-2.5139 3.1665,-2.5139c1.7496,0 3.1664,1.1249 3.1664,2.5139l0,28.9534c0,1.389 -1.4168,2.5138 -3.1664,2.5138c-1.7496,0 -3.1665,-1.1248 -3.1665,-2.5138l0,-28.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m312.42617,14.25334c0,-1.38898 1.4045,-2.50407 3.1171,-2.50407c1.7249,0 3.1172,1.11509 3.1172,2.50407l0,32.50306c0,1.389 -1.4046,2.5041 -3.1172,2.5041c-1.7249,0 -3.1171,-1.1151 -3.1171,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m330.82107,15.5331c0,-1.389 -1.4168,-2.5139 -3.1664,-2.5139c-1.7496,0 -3.1665,1.1249 -3.1665,2.5139l0,28.9534c0,1.389 1.4169,2.5138 3.1665,2.5138c1.7496,0 3.1664,-1.1248 3.1664,-2.5138l0,-28.9534z"
      />
      <path
        stroke="null"
        fill="#E5E9FF"
        d="m342.88816,20.1868c0,-1.389 -1.417,-2.5138 -3.1668,-2.5138c-1.7495,0 -3.1664,1.1248 -3.1664,2.5138l0,17.6264c0,1.389 1.4169,2.5138 3.1664,2.5138c1.7498,0 3.1668,-1.1248 3.1668,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m354.6839,18.5331c0,-1.389 -1.416,-2.5139 -3.166,-2.5139c-1.75,0 -3.166,1.1249 -3.166,2.5139l0,23.9534c0,1.389 1.416,2.5138 3.166,2.5138c1.75,0 3.166,-1.1248 3.166,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m366.7469,14.25334c0,-1.38898 -1.405,-2.50407 -3.118,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.118,-1.1151 3.118,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m378.57234,10.51386c0,-1.38898 -1.417,-2.51386 -3.167,-2.51386c-1.749,0 -3.166,1.12488 -3.166,2.51386l0,39.97224c0,1.389 1.417,2.5139 3.166,2.5139c1.75,0 3.167,-1.1249 3.167,-2.5139l0,-39.97224z"
      />
      <path
        fill="#E5E9FF"
        d="m390.60934,14.25334c0,-1.38898 -1.404,-2.50407 -3.117,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.117,-1.1151 3.117,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m396.23728,18.5331c0,-1.389 1.4169,-2.5139 3.1664,-2.5139c1.7496,0 3.1665,1.1249 3.1665,2.5139l0,23.9534c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m408.32398,21.1868c0,-1.389 1.4169,-2.5138 3.1664,-2.5138c1.7496,0 3.1665,1.1248 3.1665,2.5138l0,17.6264c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m420.42298,15.5331c0,-1.389 1.4169,-2.5139 3.1665,-2.5139c1.7496,0 3.1664,1.1249 3.1664,2.5139l0,28.9534c0,1.389 -1.4168,2.5138 -3.1664,2.5138c-1.7496,0 -3.1665,-1.1248 -3.1665,-2.5138l0,-28.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m432.55908,14.25334c0,-1.38898 1.4045,-2.50407 3.1171,-2.50407c1.7249,0 3.1172,1.11509 3.1172,2.50407l0,32.50306c0,1.389 -1.4046,2.5041 -3.1172,2.5041c-1.7249,0 -3.1171,-1.1151 -3.1171,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m450.63141,15.5331c0,-1.389 -1.4168,-2.5139 -3.1664,-2.5139c-1.7496,0 -3.1665,1.1249 -3.1665,2.5139l0,28.9534c0,1.389 1.4169,2.5138 3.1665,2.5138c1.7496,0 3.1664,-1.1248 3.1664,-2.5138l0,-28.9534z"
      />
      <path
        stroke="null"
        fill="#E5E9FF"
        d="m462.69851,20.1868c0,-1.389 -1.417,-2.5138 -3.1668,-2.5138c-1.7495,0 -3.1664,1.1248 -3.1664,2.5138l0,17.6264c0,1.389 1.4169,2.5138 3.1664,2.5138c1.7498,0 3.1668,-1.1248 3.1668,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m474.81681,18.5331c0,-1.389 -1.416,-2.5139 -3.166,-2.5139c-1.75,0 -3.166,1.1249 -3.166,2.5139l0,23.9534c0,1.389 1.416,2.5138 3.166,2.5138c1.75,0 3.166,-1.1248 3.166,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m486.55725,14.25334c0,-1.38898 -1.405,-2.50407 -3.118,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.118,-1.1151 3.118,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m498.70525,10.51386c0,-1.38898 -1.417,-2.51386 -3.167,-2.51386c-1.749,0 -3.166,1.12488 -3.166,2.51386l0,39.97224c0,1.389 1.417,2.5139 3.166,2.5139c1.75,0 3.167,-1.1249 3.167,-2.5139l0,-39.97224z"
      />
      <path
        fill="#E5E9FF"
        d="m510.74225,14.25334c0,-1.38898 -1.404,-2.50407 -3.117,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.117,-1.1151 3.117,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m516.5566,18.5331c0,-1.389 1.4169,-2.5139 3.1664,-2.5139c1.7496,0 3.1665,1.1249 3.1665,2.5139l0,23.9534c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m528.32074,21.1868c0,-1.389 1.4169,-2.5138 3.1664,-2.5138c1.7496,0 3.1665,1.1248 3.1665,2.5138l0,17.6264c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m540.41974,15.5331c0,-1.389 1.4169,-2.5139 3.1665,-2.5139c1.7496,0 3.1664,1.1249 3.1664,2.5139l0,28.9534c0,1.389 -1.4168,2.5138 -3.1664,2.5138c-1.7496,0 -3.1665,-1.1248 -3.1665,-2.5138l0,-28.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m552.55584,14.25334c0,-1.38898 1.4045,-2.50407 3.1171,-2.50407c1.7249,0 3.1172,1.11509 3.1172,2.50407l0,32.50306c0,1.389 -1.4046,2.5041 -3.1172,2.5041c-1.7249,0 -3.1171,-1.1151 -3.1171,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m570.62817,15.5331c0,-1.389 -1.4168,-2.5139 -3.1664,-2.5139c-1.7496,0 -3.1665,1.1249 -3.1665,2.5139l0,28.9534c0,1.389 1.4169,2.5138 3.1665,2.5138c1.7496,0 3.1664,-1.1248 3.1664,-2.5138l0,-28.9534z"
      />
      <path
        stroke="null"
        fill="#E5E9FF"
        d="m582.69526,20.1868c0,-1.389 -1.417,-2.5138 -3.1668,-2.5138c-1.7495,0 -3.1664,1.1248 -3.1664,2.5138l0,17.6264c0,1.389 1.4169,2.5138 3.1664,2.5138c1.7498,0 3.1668,-1.1248 3.1668,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m594.81357,18.5331c0,-1.389 -1.416,-2.5139 -3.166,-2.5139c-1.75,0 -3.166,1.1249 -3.166,2.5139l0,23.9534c0,1.389 1.416,2.5138 3.166,2.5138c1.75,0 3.166,-1.1248 3.166,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m606.55401,14.25334c0,-1.38898 -1.405,-2.50407 -3.118,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.118,-1.1151 3.118,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m618.70201,10.51386c0,-1.38898 -1.417,-2.51386 -3.167,-2.51386c-1.749,0 -3.166,1.12488 -3.166,2.51386l0,39.97224c0,1.389 1.417,2.5139 3.166,2.5139c1.75,0 3.167,-1.1249 3.167,-2.5139l0,-39.97224z"
      />
      <path
        fill="#E5E9FF"
        d="m630.73901,14.25334c0,-1.38898 -1.404,-2.50407 -3.117,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.117,-1.1151 3.117,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m636.36034,18.5331c0,-1.389 1.4169,-2.5139 3.1664,-2.5139c1.7496,0 3.1665,1.1249 3.1665,2.5139l0,23.9534c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m648.44704,21.1868c0,-1.389 1.4169,-2.5138 3.1664,-2.5138c1.7496,0 3.1665,1.1248 3.1665,2.5138l0,17.6264c0,1.389 -1.4169,2.5138 -3.1665,2.5138c-1.7495,0 -3.1664,-1.1248 -3.1664,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m660.54604,15.5331c0,-1.389 1.4169,-2.5139 3.1665,-2.5139c1.7496,0 3.1664,1.1249 3.1664,2.5139l0,28.9534c0,1.389 -1.4168,2.5138 -3.1664,2.5138c-1.7496,0 -3.1665,-1.1248 -3.1665,-2.5138l0,-28.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m672.35958,14.25334c0,-1.38898 1.4045,-2.50407 3.1171,-2.50407c1.7249,0 3.1172,1.11509 3.1172,2.50407l0,32.50306c0,1.389 -1.4046,2.5041 -3.1172,2.5041c-1.7249,0 -3.1171,-1.1151 -3.1171,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m690.75448,15.5331c0,-1.389 -1.4168,-2.5139 -3.1664,-2.5139c-1.7496,0 -3.1665,1.1249 -3.1665,2.5139l0,28.9534c0,1.389 1.4169,2.5138 3.1665,2.5138c1.7496,0 3.1664,-1.1248 3.1664,-2.5138l0,-28.9534z"
      />
      <path
        stroke="null"
        fill="#E5E9FF"
        d="m702.82157,20.1868c0,-1.389 -1.417,-2.5138 -3.1668,-2.5138c-1.7495,0 -3.1664,1.1248 -3.1664,2.5138l0,17.6264c0,1.389 1.4169,2.5138 3.1664,2.5138c1.7498,0 3.1668,-1.1248 3.1668,-2.5138l0,-17.6264z"
      />
      <path
        fill="#E5E9FF"
        d="m714.61732,18.5331c0,-1.389 -1.416,-2.5139 -3.166,-2.5139c-1.75,0 -3.166,1.1249 -3.166,2.5139l0,23.9534c0,1.389 1.416,2.5138 3.166,2.5138c1.75,0 3.166,-1.1248 3.166,-2.5138l0,-23.9534z"
      />
      <path
        fill="#E5E9FF"
        d="m726.68032,14.25334c0,-1.38898 -1.405,-2.50407 -3.118,-2.50407c-1.725,0 -3.117,1.11509 -3.117,2.50407l0,32.50306c0,1.389 1.405,2.5041 3.117,2.5041c1.725,0 3.118,-1.1151 3.118,-2.5041l0,-32.50306z"
      />
      <path
        fill="#E5E9FF"
        d="m738.69576,10.51386c0,-1.38898 -1.417,-2.51386 -3.167,-2.51386c-1.749,0 -3.166,1.12488 -3.166,2.51386l0,39.97224c0,1.389 1.417,2.5139 3.166,2.5139c1.75,0 3.167,-1.1249 3.167,-2.5139l0,-39.97224z"
      />
    </StyledSearchAudioWave>
  );
};

export default SearchAudioWave;

const createfillPathsLoop = () => {
  let styles = "";

  for (let i = 0; i < 62; i += 1) {
    styles += `
      path:nth-child(${i}) {
         animation-delay: ${i * 0.3}s;
       }
     `;
  }

  return css`
    ${styles}
  `;
};

const fillPath = keyframes`
    0% {
        fill: #e5e9ff;
    }
    100% {
        fill: #4974f6;
    }
`;

const StyledSearchAudioWave = styled.svg`
  max-width: 100%;
  transform: scale(0.8);

  path {
    animation: ${fillPath} 0.3s forwards;
    animation-delay: 18.6s;
  }

  ${createfillPathsLoop()}
`;
